document.addEventListener('DOMContentLoaded', function () {
  // Starfield
  var c = document.getElementById('stars');
  if (c) {
    for (var i = 0; i < 180; i++) {
      var s = document.createElement('div');
      s.className = 'star';
      var sz = Math.random() * 2.5 + 0.5;
      s.style.cssText = 'width:'+sz+'px;height:'+sz+'px;top:'+Math.random()*100+'%;left:'+Math.random()*100+'%;--d:'+(Math.random()*3+1).toFixed(1)+'s;animation-delay:'+(Math.random()*3).toFixed(1)+'s';
      c.appendChild(s);
    }
  }

  // Ajax add to cart feedback
  var forms = document.querySelectorAll('form[action="/cart/add"]');
  forms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) {
        var orig = btn.textContent;
        btn.textContent = '✓ Added!';
        btn.style.background = 'linear-gradient(90deg,#006600,#00aa00)';
        setTimeout(function() {
          btn.textContent = orig;
          btn.style.background = '';
        }, 1500);
      }
    });
  });
});
